import { combineReducers } from 'redux'
import detailSearch, { DetailSearchState } from './detailSearch'
import category, { CategoryState } from './category'

export interface GnbState {
  detailSearch: DetailSearchState
  category: CategoryState
}

const reducers = combineReducers({
  detailSearch,
  category,
})

export default reducers
